function removeEmpty(obj) {
  // If it's an array, map each element and return the result as an array
  if (Array.isArray(obj)) {
    return obj.map(item => (typeof item === 'object' ? removeEmpty(item) : item));
  }

  // If it's an object, remove empty attributes and return the result as an object
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([, v]) => v != null)
      .map(([k, v]) => [k, v === Object(v) ? removeEmpty(v) : v]),
  );
}

export default removeEmpty;
